import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { PublicComponent } from './public.component';
import { ResetPasswordRequestComponent } from './components/reset-password-request/reset-password-request.component';
import { ResetPasswordProcessComponent } from './components/reset-password-process/reset-password-process.component';
import { UnauthorizedErrorComponent } from './error/unauthorized/unauthorized.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { UnregisteredErrorComponent } from './error/unregistered/unregistered.component';
import { RegisterSuccessComponent } from './sucess/register-success/register-success.component';
import { EmailSentComponent } from './sucess/email-sent/email-sent.component';
import { NotActivatedErrorComponent } from './error/not-activated/not-activated.component';
import { ContactPageModule } from '@app/contact-page/contact-page.module';
import { UserRegistrationRequestService } from '@app/registration-request/services/user-registration-request.service';

@NgModule({
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, SharedModule, ContactPageModule],
  declarations: [
    DisclaimerComponent,
    PublicComponent,
    ResetPasswordRequestComponent,
    ResetPasswordProcessComponent,
    UnregisteredErrorComponent,
    UnauthorizedErrorComponent,
    NotActivatedErrorComponent,
    RegisterSuccessComponent,
    UserRegistrationComponent,
    EmailSentComponent,
  ],
  providers: [UserRegistrationRequestService]
})
export class PublicModule {}
